import { LocaleType } from './Locale';

const theLocale: LocaleType = {
    locale: 'sa',
    alia: 'sa',
    region: 'الشرق الأوسط',
    regionText: 'الشرق الأوسط',
    language: 'الشرق الأوسط',
    languageText: 'العربية',
    appId: 16,
    // acceptLanguage: 'sa_AR,sa;q=0.9',
    acceptLanguage: 'sa-AR,sa;q=0.9',
};
export default theLocale;
